import React from 'react';
import { Link, Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { Layout, Space } from 'antd';
import { AuthorizedRoute } from './auth/components/AuthorizedRoute';
import { IdleSessionManager } from './auth/components/IdleSessionManager';
import { LogoutButton, UserInfo } from './auth/components/AuthComponents';
import DataModelViewerApp from './App';
import ApplicationStatusEditor from './features/ApplicationStatusEditor/ApplicationStatusEditor';
import SectionNav, { SECTION_ROUTES } from './layout/SectionNav';
import LandingPage from './layout/LandingPage';

const { Header, Content } = Layout;

// Section nav is only shown when inside a feature route, not on the landing page
const FEATURE_ROUTES = Object.values(SECTION_ROUTES);

const AppWithAuth: React.FC = () => {
    const { pathname } = useLocation();
    const isFeatureRoute = FEATURE_ROUTES.some(r => pathname.startsWith(r));

    return (
        <AuthorizedRoute>
            <IdleSessionManager>
                <Layout style={{ minHeight: '100vh' }}>
                    <Header style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        backgroundColor: 'var(--bg-primary)',
                        padding: '0 24px',
                        borderBottom: '1px solid #f0f0f0',
                    }}>
                        <Link
                            to="/"
                            style={{ color: 'var(--text-primary)', fontSize: 18, fontWeight: 600, textDecoration: 'none' }}
                        >
                            LifeScience Implementations Portal
                        </Link>
                        <Space>
                            <UserInfo showEmail={false} />
                            <LogoutButton type="text" size="small" />
                        </Space>
                    </Header>

                    {isFeatureRoute && <SectionNav />}

                    <Content style={{ backgroundColor: 'var(--bg-primary)', overflow: 'auto' }}>
                        <Switch>
                            <Route exact path="/" component={LandingPage} />
                            <Route path={SECTION_ROUTES.formEditor} component={DataModelViewerApp} />
                            <Route path={SECTION_ROUTES.applicationStatusEditor} component={ApplicationStatusEditor} />
                            <Redirect to="/" />
                        </Switch>
                    </Content>
                </Layout>
            </IdleSessionManager>
        </AuthorizedRoute>
    );
};

export default AppWithAuth;
